/**
 * Bootstrap service, that provides a convient way to access the bootstrap object returned from the server
 */
import {i18n} from "../components/app/AppSetup"
class BootstrapService
{
    // Singleton constructor
    constructor()
    {
        if (!this.instance)
        {
            this.instance = this
            this.bootstrapObj = {}
        }
        return this.instance
    }

    /**
     * Called from the userSessionService after a successfuly connection to the server, we initialize the object
     * @param bootstrapObj the object from the server
     */
    initialize (bootstrapObj)
    {
        this.bootstrapObj = bootstrapObj
    }

    /**
     * Get the list of NA2W Water and Gas Device Types
     * @returns {*|*[]}
     */
    getNA2WWaterGasDeviceTypes ()
    {
        return this.bootstrapObj.deviceTypes ? this.bootstrapObj.deviceTypes.na2wWaterGasMeters : []
    }

    supportsStaticRebroadcast(deviceType) {
        if (this.bootstrapObj.staticRebroadcasterDeviceTypes) {
            return this.bootstrapObj.staticRebroadcasterDeviceTypes.includes(deviceType);
        }
        return false;
    }
    /**
     * @returns timezones from bootstrap object as array of objects
     */
    getTimezones() {
        if (this.bootstrapObj.timeZones == null)
        {
            return ([])
        }
        return this.bootstrapObj.timeZones.map(tz => {
            return {
                value: tz,
                text: tz.replace(/_/g, " ")
            };
        });
    }

    getNADeviceTypeCategories() {
        // since most of the device type categories belongs to NA so its better to maintain list which does not belongs to NA
        // this is the list of categories which does not belongs to NA
        let notSupportedCategories = ['slottedPollResponseDevices']
        if (this.bootstrapObj.deviceTypes) {
            let deviceTypesCategories = Object.keys(this.bootstrapObj.deviceTypes)
            // filter out the categories that does not belongs to NA
            return deviceTypesCategories.reduce((items, item) => {
                if (!notSupportedCategories.includes(item)) {
                    items.push({id: item, name: 'deviceTypeCategories.' + item})
                }       
                return items  
            }, [{name: 'common.notset', id: null}])
        }
    }
    getArqivaDeviceTypeCategories() {
        // since their are only couple of device type categories belongs to Arqiva or SPR, so its better to maintain list which belongs to Arqiva
        // this is the list of categories which belongs to Arqiva
        let supportedCategories = ['slottedPollResponseDevices', 'tunableMeters', 'compulsoryRepeaters']
        if (this.bootstrapObj.deviceTypes) {
            let deviceTypesCategories = Object.keys(this.bootstrapObj.deviceTypes)
            // filter out the categories that belongs to Arqiva
            return deviceTypesCategories.reduce((items, item) => {
                if (supportedCategories.includes(item)) {
                    items.push({id: item, name: 'deviceTypeCategories.' + item})
                }       
                return items
                // default load not set selectable item  
            }, [{name: 'common.notset', id: null}])
        }
    }

    getComparableFilters(filters) {
        //get mapping-- filter statistic : comparable filter type
        let comparableFieldsMap = this.bootstrapObj.comparableTypes

        //get i18n translation keys for these filters
        let comparableFieldTranslations = {}

        for(let filter of filters) {
           let stat = filter["statistic"]
           let name = stat

           if("name" in filter) {
              name = filter["name"]
           }

           comparableFieldTranslations[stat] = name
        }

        //using the previous mappings, create:
        //list of comparable fields with associated statistic, type AND translated name
        //list of comparable fields by type first
                
        let comparableFields = []
        let comparableFieldsByType = {}
        
        for (let compFieldsKey in comparableFieldsMap) {
            let newKey = comparableFieldsMap[compFieldsKey]
        
            let newValue = {}
        
            let stat = compFieldsKey
            let name = stat
            let type = comparableFieldsMap[compFieldsKey]
        
            if (stat in comparableFieldTranslations) {
                name = i18n.global.t(comparableFieldTranslations[stat])
            //if it is NOT in the translation dict, then it is not a filter we are interested in
            //the list of filters we want in the comparable fields mapping have been passed into this function
            //only the intersection between filters we want and filters that are comparable end up in the map
            } else {
                continue
            }
        
            newValue["statistic"] = stat
            newValue["name"] = name
        
            if(!(newKey in comparableFieldsByType)) {
                comparableFieldsByType[newKey] = []
            } 
        
            comparableFieldsByType[newKey].push(newValue)

            let comparableFieldsDict = {}
            comparableFieldsDict["name"] = name
            comparableFieldsDict["statistic"] = stat
            comparableFieldsDict["type"] = type
        
            comparableFields.push(comparableFieldsDict)
        }

        return {
            comparableFieldsByType,
            comparableFields
        }
    }
}

export default new BootstrapService()
